import { useIntegrations } from '@integration-app/react';
import { useIntegrationApp } from '@integration-app/react';
import { SkillCard } from './SkillCard';
import { useState } from 'react';
import { Label } from 'src/components/Label';
import { SelectBox } from 'src/components/SelectBox';
import { MultiSelectBox } from 'src/components/MultiSelectBox';

const searchKeys = ['hubspot'];

const HUBSPOT_DATA_TYPES = ['Contacts', 'Companies', 'Deals', 'Tasks', 'Notes'];

export const SearchSkill = ({
  config,
  onConfigChange,
}: {
  config: object;
  onConfigChange?: (config: object) => void;
}) => {
  const integrationApp = useIntegrationApp();
  const { integrations } = useIntegrations();
  const searchIntegrations = integrations.filter((integration) =>
    searchKeys.includes(integration.key),
  );
  const connectedSearch = searchIntegrations.filter(
    (integration) => !!integration.connection,
  );
  const [selectedSearchIntegration, setSelectedSearchIntegration] =
    useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <SkillCard title="SEARCH">
      <div className="flex gap-4">
        <div>
          <Label>Data Provider</Label>
          <SelectBox
            options={searchIntegrations.map((integration) => ({
              value: integration.key,
              label: integration.name,
            }))}
            value={
              selectedSearchIntegration
                ? {
                    value: selectedSearchIntegration,
                    label: searchIntegrations.find(
                      (integration) =>
                        integration.key === selectedSearchIntegration,
                    )?.name,
                  }
                : null
            }
            onChange={(value) => {
              if (
                !connectedSearch.find(
                  (integration) => integration.key === value,
                )
              ) {
                integrationApp.integration(value).open({
                  onClose: async () => {
                    const integration = await integrationApp
                      .integration(value)
                      .get();
                    if (integration.connection) {
                      setSelectedSearchIntegration(value);
                      return;
                    }
                    setSelectedSearchIntegration('');
                  },
                });
              } else {
                setSelectedSearchIntegration(value);
              }
            }}
          />
        </div>
        {selectedSearchIntegration === 'hubspot' && (
          <div>
            <Label>Data Types</Label>
            <MultiSelectBox
              options={HUBSPOT_DATA_TYPES.map((tag) => ({
                value: tag,
                label: tag,
              }))}
              variant="outlined"
              color="primary"
              size="medium"
              className="w-full"
            />
          </div>
        )}
      </div>
    </SkillCard>
  );
};
